<template>
  <div class="editor">
    <editor
      ref="tinymceEditor"
      id="tinymce-editor"
      api-key="qagffr3pkuv17a8on1afax661irst1hbr4e6tbv888sz91jc"
      :init="{
        height: 500,
        menubar: false,
        plugins: [
          'advlist anchor autolink autosave code codesample directionality fullscreen hr image imagetools insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textpattern visualblocks visualchars wordcount',
        ],
        toolbar: [
          'searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent blockquote undo redo removeformat subscript superscript code codesample',
          'hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen',
        ],
        color_map: [
          '000000', 'Black',
          '808080', 'Gray',
          'FFFFFF', 'White',
          'FF0000', 'Red',
          'FFFF00', 'Yellow',
          '008000', 'Green',
          '0000FF', 'Blue'
        ],
        content_style: 'body { color: white !important; }',
      }"
      @input="emitContent"
    ></editor>
  </div>
</template>

<script>
import Editor from "vue-tinymce-editor";

export default {
  components: {
    editor: Editor,
  },
  methods: {
    emitContent(content) {
      this.$emit("input", content);
    },

    resetEditor() {
      const tinymceEditor = this.$refs.tinymceEditor.editor;
      if (tinymceEditor) {
        tinymceEditor.setContent("");
      }
    },
  },
};
</script>
